export enum ActiveDirectoryType {
  Azure,
  Adfs
}
